import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useFormattedDate } from "@/hooks/metrics/useFormattedDate";

export function DateCellActivityHighlighted(props: GridRenderCellParams) {
  const formatted = useFormattedDate(props.value);
  const communicating = props.row.statusData?.isDeviceCommunicating;

  return (
    <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
      <Typography color={!communicating ? "error" : "black"}>{formatted}</Typography>
    </Box>
  );
}
